import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _RefundBackLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m4 8-.354.354L3.293 8l.353-.354zm5 11.5a.5.5 0 0 1 0-1zm-.354-6.146-5-5 .708-.708 5 5zm-5-5.708 5-5 .708.708-5 5zM4 7.5h10.5v1H4zm10.5 12H9v-1h5.5zm6-6a6 6 0 0 1-6 6v-1a5 5 0 0 0 5-5zm-6-6a6 6 0 0 1 6 6h-1a5 5 0 0 0-5-5z" })));
}
const RefundBackLight = forwardRef(_RefundBackLight);
export { RefundBackLight };
